import { Injectable, inject } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { IReportExportStatusDto } from '@core/interfaces/api/reports/reports-export-status-dto.interface';
import { AuthStorageService } from '@core/services/auth-storage.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MessageReportService } from '../../modules/reports/use-cases/message-report.service';

@Injectable({ providedIn: 'root' })
export class MessageNotificationService {
  private readonly messaging = inject(Messaging);

  private readonly authStorageService = inject(AuthStorageService);
  private readonly reportNotificationService = inject(MessageReportService);

  constructor() {
    this.initFirebaseMessaging();
  }

  private initFirebaseMessaging(): void {
    onMessage(this.messaging, payload => {
      if (!payload.data) {
        console.warn('Payload data is empty or undefined');
        return;
      }

      this.reportNotificationService.addNotification(
        payload.data as unknown as IReportExportStatusDto
      );
    });

    const channel = new BroadcastChannel('fcm_notifications');
    channel.onmessage = ({ data }) => {
      this.reportNotificationService.addNotification(data as IReportExportStatusDto);
    };
  }

  requestPermission(): Observable<string> {
    return new Observable<string>(subscriber => {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          getToken(this.messaging, { vapidKey: environment.firebaseConfig.vapidKey })
            .then(token => {
              this.authStorageService.setNotificationToken(token);
              subscriber.next(token ?? '');
              subscriber.complete();
            })
            .catch(err => subscriber.error(err));
        } else {
          subscriber.error('Permission not granted');
        }
      });
    });
  }
}
